/* eslint-disable */
import { Timestamp } from '../../../google/protobuf/timestamp';
import { ButtonData } from './plugin_button';
import { CodeBlockData } from './node_code_block';
import { DividerData } from './plugin_divider';
import { FileData } from './plugin_file';
import { GalleryData } from './plugin_gallery';
import { GIFData } from './plugin_gif';
import { HeadingData } from './node_heading';
import { HTMLData } from './plugin_html';
import { ImageData } from './plugin_image';
import { LinkPreviewData } from './plugin_link_preview';
import { MapData } from './plugin_map';
import { ParagraphData } from './node_paragraph';
import { PollData } from './plugin_poll';
import { AppEmbedData } from './plugin_app_embed';
import { VideoData } from './plugin_video';
import { EmbedData } from './plugin_embed';
import { CollapsibleListData } from './plugin_collapsible_list';
import { TableData } from './plugin_table';
import { TableCellData } from './plugin_table_cell';
import { Struct } from './struct';
import { AudioData } from './plugin_audio';
import { OrderedListData, BulletedListData } from './node_list';
import { BlockquoteData } from './node_blockquote';
import { AnchorData } from './decoration_anchor';
import { ColorData } from './decoration_color';
import { LinkData } from './decoration_link';
import { MentionData } from './decoration_mention';
import { FontSizeData } from './decoration_fontsize';
import { SpoilerData } from './decoration_spoiler';
import { Node_Type, Decoration_Type } from './rich_content.enums';
export function node_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'PARAGRAPH':
            return Node_Type.PARAGRAPH;
        case 1:
        case 'TEXT':
            return Node_Type.TEXT;
        case 2:
        case 'HEADING':
            return Node_Type.HEADING;
        case 3:
        case 'BULLETED_LIST':
            return Node_Type.BULLETED_LIST;
        case 4:
        case 'ORDERED_LIST':
            return Node_Type.ORDERED_LIST;
        case 5:
        case 'LIST_ITEM':
            return Node_Type.LIST_ITEM;
        case 6:
        case 'BLOCKQUOTE':
            return Node_Type.BLOCKQUOTE;
        case 7:
        case 'CODE_BLOCK':
            return Node_Type.CODE_BLOCK;
        case 8:
        case 'VIDEO':
            return Node_Type.VIDEO;
        case 9:
        case 'DIVIDER':
            return Node_Type.DIVIDER;
        case 10:
        case 'FILE':
            return Node_Type.FILE;
        case 11:
        case 'GALLERY':
            return Node_Type.GALLERY;
        case 12:
        case 'GIF':
            return Node_Type.GIF;
        case 13:
        case 'HTML':
            return Node_Type.HTML;
        case 14:
        case 'IMAGE':
            return Node_Type.IMAGE;
        case 15:
        case 'LINK_PREVIEW':
            return Node_Type.LINK_PREVIEW;
        case 16:
        case 'MAP':
            return Node_Type.MAP;
        case 17:
        case 'POLL':
            return Node_Type.POLL;
        case 18:
        case 'APP_EMBED':
            return Node_Type.APP_EMBED;
        case 19:
        case 'BUTTON':
            return Node_Type.BUTTON;
        case 20:
        case 'COLLAPSIBLE_LIST':
            return Node_Type.COLLAPSIBLE_LIST;
        case 21:
        case 'TABLE':
            return Node_Type.TABLE;
        case 22:
        case 'EMBED':
            return Node_Type.EMBED;
        case 23:
        case 'COLLAPSIBLE_ITEM':
            return Node_Type.COLLAPSIBLE_ITEM;
        case 24:
        case 'COLLAPSIBLE_ITEM_TITLE':
            return Node_Type.COLLAPSIBLE_ITEM_TITLE;
        case 25:
        case 'COLLAPSIBLE_ITEM_BODY':
            return Node_Type.COLLAPSIBLE_ITEM_BODY;
        case 26:
        case 'TABLE_CELL':
            return Node_Type.TABLE_CELL;
        case 27:
        case 'TABLE_ROW':
            return Node_Type.TABLE_ROW;
        case 28:
        case 'EXTERNAL':
            return Node_Type.EXTERNAL;
        case 29:
        case 'AUDIO':
            return Node_Type.AUDIO;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Node_Type.UNRECOGNIZED;
    }
}
export function node_TypeToJSON(object) {
    switch (object) {
        case Node_Type.PARAGRAPH:
            return 'PARAGRAPH';
        case Node_Type.TEXT:
            return 'TEXT';
        case Node_Type.HEADING:
            return 'HEADING';
        case Node_Type.BULLETED_LIST:
            return 'BULLETED_LIST';
        case Node_Type.ORDERED_LIST:
            return 'ORDERED_LIST';
        case Node_Type.LIST_ITEM:
            return 'LIST_ITEM';
        case Node_Type.BLOCKQUOTE:
            return 'BLOCKQUOTE';
        case Node_Type.CODE_BLOCK:
            return 'CODE_BLOCK';
        case Node_Type.VIDEO:
            return 'VIDEO';
        case Node_Type.DIVIDER:
            return 'DIVIDER';
        case Node_Type.FILE:
            return 'FILE';
        case Node_Type.GALLERY:
            return 'GALLERY';
        case Node_Type.GIF:
            return 'GIF';
        case Node_Type.HTML:
            return 'HTML';
        case Node_Type.IMAGE:
            return 'IMAGE';
        case Node_Type.LINK_PREVIEW:
            return 'LINK_PREVIEW';
        case Node_Type.MAP:
            return 'MAP';
        case Node_Type.POLL:
            return 'POLL';
        case Node_Type.APP_EMBED:
            return 'APP_EMBED';
        case Node_Type.BUTTON:
            return 'BUTTON';
        case Node_Type.COLLAPSIBLE_LIST:
            return 'COLLAPSIBLE_LIST';
        case Node_Type.TABLE:
            return 'TABLE';
        case Node_Type.EMBED:
            return 'EMBED';
        case Node_Type.COLLAPSIBLE_ITEM:
            return 'COLLAPSIBLE_ITEM';
        case Node_Type.COLLAPSIBLE_ITEM_TITLE:
            return 'COLLAPSIBLE_ITEM_TITLE';
        case Node_Type.COLLAPSIBLE_ITEM_BODY:
            return 'COLLAPSIBLE_ITEM_BODY';
        case Node_Type.TABLE_CELL:
            return 'TABLE_CELL';
        case Node_Type.TABLE_ROW:
            return 'TABLE_ROW';
        case Node_Type.EXTERNAL:
            return 'EXTERNAL';
        case Node_Type.AUDIO:
            return 'AUDIO';
        default:
            return 'UNKNOWN';
    }
}
export function decoration_TypeFromJSON(object) {
    switch (object) {
        case 0:
        case 'BOLD':
            return Decoration_Type.BOLD;
        case 1:
        case 'ITALIC':
            return Decoration_Type.ITALIC;
        case 2:
        case 'UNDERLINE':
            return Decoration_Type.UNDERLINE;
        case 3:
        case 'SPOILER':
            return Decoration_Type.SPOILER;
        case 4:
        case 'ANCHOR':
            return Decoration_Type.ANCHOR;
        case 5:
        case 'MENTION':
            return Decoration_Type.MENTION;
        case 6:
        case 'LINK':
            return Decoration_Type.LINK;
        case 7:
        case 'COLOR':
            return Decoration_Type.COLOR;
        case 8:
        case 'FONT_SIZE':
            return Decoration_Type.FONT_SIZE;
        case 9:
        case 'EXTERNAL':
            return Decoration_Type.EXTERNAL;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return Decoration_Type.UNRECOGNIZED;
    }
}
export function decoration_TypeToJSON(object) {
    switch (object) {
        case Decoration_Type.BOLD:
            return 'BOLD';
        case Decoration_Type.ITALIC:
            return 'ITALIC';
        case Decoration_Type.UNDERLINE:
            return 'UNDERLINE';
        case Decoration_Type.SPOILER:
            return 'SPOILER';
        case Decoration_Type.ANCHOR:
            return 'ANCHOR';
        case Decoration_Type.MENTION:
            return 'MENTION';
        case Decoration_Type.LINK:
            return 'LINK';
        case Decoration_Type.COLOR:
            return 'COLOR';
        case Decoration_Type.FONT_SIZE:
            return 'FONT_SIZE';
        case Decoration_Type.EXTERNAL:
            return 'EXTERNAL';
        default:
            return 'UNKNOWN';
    }
}
const baseRichContent = {};
export const RichContent = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseRichContent);
        message.nodes = ((_a = object.nodes) !== null && _a !== void 0 ? _a : []).map((e) => Node.fromJSON(e));
        message.metadata =
            object.metadata !== undefined && object.metadata !== null
                ? Metadata.fromJSON(object.metadata)
                : undefined;
        message.documentStyle =
            object.documentStyle !== undefined && object.documentStyle !== null
                ? DocumentStyle.fromJSON(object.documentStyle)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.nodes) {
            obj.nodes = message.nodes.map(e => (e ? Node.toJSON(e) : undefined));
        }
        else {
            obj.nodes = [];
        }
        message.metadata !== undefined &&
            (obj.metadata = message.metadata ? Metadata.toJSON(message.metadata) : undefined);
        message.documentStyle !== undefined &&
            (obj.documentStyle = message.documentStyle
                ? DocumentStyle.toJSON(message.documentStyle)
                : undefined);
        return obj;
    },
};
const baseNode = { type: Node_Type.PARAGRAPH, id: '' };
export const Node = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseNode);
        message.type =
            object.type !== undefined && object.type !== null
                ? node_TypeFromJSON(object.type)
                : Node_Type.PARAGRAPH;
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : '';
        message.nodes = ((_a = object.nodes) !== null && _a !== void 0 ? _a : []).map((e) => Node.fromJSON(e));
        message.style =
            object.style !== undefined && object.style !== null
                ? NodeStyle.fromJSON(object.style)
                : undefined;
        message.buttonData =
            object.buttonData !== undefined && object.buttonData !== null
                ? ButtonData.fromJSON(object.buttonData)
                : undefined;
        message.codeBlockData =
            object.codeBlockData !== undefined && object.codeBlockData !== null
                ? CodeBlockData.fromJSON(object.codeBlockData)
                : undefined;
        message.dividerData =
            object.dividerData !== undefined && object.dividerData !== null
                ? DividerData.fromJSON(object.dividerData)
                : undefined;
        message.fileData =
            object.fileData !== undefined && object.fileData !== null
                ? FileData.fromJSON(object.fileData)
                : undefined;
        message.galleryData =
            object.galleryData !== undefined && object.galleryData !== null
                ? GalleryData.fromJSON(object.galleryData)
                : undefined;
        message.gifData =
            object.gifData !== undefined && object.gifData !== null
                ? GIFData.fromJSON(object.gifData)
                : undefined;
        message.headingData =
            object.headingData !== undefined && object.headingData !== null
                ? HeadingData.fromJSON(object.headingData)
                : undefined;
        message.htmlData =
            object.htmlData !== undefined && object.htmlData !== null
                ? HTMLData.fromJSON(object.htmlData)
                : undefined;
        message.imageData =
            object.imageData !== undefined && object.imageData !== null
                ? ImageData.fromJSON(object.imageData)
                : undefined;
        message.linkPreviewData =
            object.linkPreviewData !== undefined && object.linkPreviewData !== null
                ? LinkPreviewData.fromJSON(object.linkPreviewData)
                : undefined;
        message.mapData =
            object.mapData !== undefined && object.mapData !== null
                ? MapData.fromJSON(object.mapData)
                : undefined;
        message.paragraphData =
            object.paragraphData !== undefined && object.paragraphData !== null
                ? ParagraphData.fromJSON(object.paragraphData)
                : undefined;
        message.pollData =
            object.pollData !== undefined && object.pollData !== null
                ? PollData.fromJSON(object.pollData)
                : undefined;
        message.textData =
            object.textData !== undefined && object.textData !== null
                ? TextData.fromJSON(object.textData)
                : undefined;
        message.appEmbedData =
            object.appEmbedData !== undefined && object.appEmbedData !== null
                ? AppEmbedData.fromJSON(object.appEmbedData)
                : undefined;
        message.videoData =
            object.videoData !== undefined && object.videoData !== null
                ? VideoData.fromJSON(object.videoData)
                : undefined;
        message.embedData =
            object.embedData !== undefined && object.embedData !== null
                ? EmbedData.fromJSON(object.embedData)
                : undefined;
        message.collapsibleListData =
            object.collapsibleListData !== undefined && object.collapsibleListData !== null
                ? CollapsibleListData.fromJSON(object.collapsibleListData)
                : undefined;
        message.tableData =
            object.tableData !== undefined && object.tableData !== null
                ? TableData.fromJSON(object.tableData)
                : undefined;
        message.tableCellData =
            object.tableCellData !== undefined && object.tableCellData !== null
                ? TableCellData.fromJSON(object.tableCellData)
                : undefined;
        message.externalData =
            object.externalData !== undefined && object.externalData !== null
                ? Struct.fromJSON(object.externalData)
                : undefined;
        message.audioData =
            object.audioData !== undefined && object.audioData !== null
                ? AudioData.fromJSON(object.audioData)
                : undefined;
        message.orderedListData =
            object.orderedListData !== undefined && object.orderedListData !== null
                ? OrderedListData.fromJSON(object.orderedListData)
                : undefined;
        message.bulletedListData =
            object.bulletedListData !== undefined && object.bulletedListData !== null
                ? BulletedListData.fromJSON(object.bulletedListData)
                : undefined;
        message.blockquoteData =
            object.blockquoteData !== undefined && object.blockquoteData !== null
                ? BlockquoteData.fromJSON(object.blockquoteData)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = node_TypeToJSON(message.type));
        message.id !== undefined && (obj.id = message.id);
        if (message.nodes) {
            obj.nodes = message.nodes.map(e => (e ? Node.toJSON(e) : undefined));
        }
        else {
            obj.nodes = [];
        }
        message.style !== undefined &&
            (obj.style = message.style ? NodeStyle.toJSON(message.style) : undefined);
        message.buttonData !== undefined &&
            (obj.buttonData = message.buttonData ? ButtonData.toJSON(message.buttonData) : undefined);
        message.codeBlockData !== undefined &&
            (obj.codeBlockData = message.codeBlockData
                ? CodeBlockData.toJSON(message.codeBlockData)
                : undefined);
        message.dividerData !== undefined &&
            (obj.dividerData = message.dividerData ? DividerData.toJSON(message.dividerData) : undefined);
        message.fileData !== undefined &&
            (obj.fileData = message.fileData ? FileData.toJSON(message.fileData) : undefined);
        message.galleryData !== undefined &&
            (obj.galleryData = message.galleryData ? GalleryData.toJSON(message.galleryData) : undefined);
        message.gifData !== undefined &&
            (obj.gifData = message.gifData ? GIFData.toJSON(message.gifData) : undefined);
        message.headingData !== undefined &&
            (obj.headingData = message.headingData ? HeadingData.toJSON(message.headingData) : undefined);
        message.htmlData !== undefined &&
            (obj.htmlData = message.htmlData ? HTMLData.toJSON(message.htmlData) : undefined);
        message.imageData !== undefined &&
            (obj.imageData = message.imageData ? ImageData.toJSON(message.imageData) : undefined);
        message.linkPreviewData !== undefined &&
            (obj.linkPreviewData = message.linkPreviewData
                ? LinkPreviewData.toJSON(message.linkPreviewData)
                : undefined);
        message.mapData !== undefined &&
            (obj.mapData = message.mapData ? MapData.toJSON(message.mapData) : undefined);
        message.paragraphData !== undefined &&
            (obj.paragraphData = message.paragraphData
                ? ParagraphData.toJSON(message.paragraphData)
                : undefined);
        message.pollData !== undefined &&
            (obj.pollData = message.pollData ? PollData.toJSON(message.pollData) : undefined);
        message.textData !== undefined &&
            (obj.textData = message.textData ? TextData.toJSON(message.textData) : undefined);
        message.appEmbedData !== undefined &&
            (obj.appEmbedData = message.appEmbedData
                ? AppEmbedData.toJSON(message.appEmbedData)
                : undefined);
        message.videoData !== undefined &&
            (obj.videoData = message.videoData ? VideoData.toJSON(message.videoData) : undefined);
        message.embedData !== undefined &&
            (obj.embedData = message.embedData ? EmbedData.toJSON(message.embedData) : undefined);
        message.collapsibleListData !== undefined &&
            (obj.collapsibleListData = message.collapsibleListData
                ? CollapsibleListData.toJSON(message.collapsibleListData)
                : undefined);
        message.tableData !== undefined &&
            (obj.tableData = message.tableData ? TableData.toJSON(message.tableData) : undefined);
        message.tableCellData !== undefined &&
            (obj.tableCellData = message.tableCellData
                ? TableCellData.toJSON(message.tableCellData)
                : undefined);
        message.externalData !== undefined &&
            (obj.externalData = message.externalData ? Struct.toJSON(message.externalData) : undefined);
        message.audioData !== undefined &&
            (obj.audioData = message.audioData ? AudioData.toJSON(message.audioData) : undefined);
        message.orderedListData !== undefined &&
            (obj.orderedListData = message.orderedListData
                ? OrderedListData.toJSON(message.orderedListData)
                : undefined);
        message.bulletedListData !== undefined &&
            (obj.bulletedListData = message.bulletedListData
                ? BulletedListData.toJSON(message.bulletedListData)
                : undefined);
        message.blockquoteData !== undefined &&
            (obj.blockquoteData = message.blockquoteData
                ? BlockquoteData.toJSON(message.blockquoteData)
                : undefined);
        return obj;
    },
};
const baseNodeStyle = {};
export const NodeStyle = {
    fromJSON(object) {
        const message = Object.assign({}, baseNodeStyle);
        message.paddingTop =
            object.paddingTop !== undefined && object.paddingTop !== null
                ? String(object.paddingTop)
                : undefined;
        message.paddingBottom =
            object.paddingBottom !== undefined && object.paddingBottom !== null
                ? String(object.paddingBottom)
                : undefined;
        message.backgroundColor =
            object.backgroundColor !== undefined && object.backgroundColor !== null
                ? String(object.backgroundColor)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.paddingTop !== undefined && (obj.paddingTop = message.paddingTop);
        message.paddingBottom !== undefined && (obj.paddingBottom = message.paddingBottom);
        message.backgroundColor !== undefined && (obj.backgroundColor = message.backgroundColor);
        return obj;
    },
};
const baseTextData = { text: '' };
export const TextData = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseTextData);
        message.text = object.text !== undefined && object.text !== null ? String(object.text) : '';
        message.decorations = ((_a = object.decorations) !== null && _a !== void 0 ? _a : []).map((e) => Decoration.fromJSON(e));
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.text !== undefined && (obj.text = message.text);
        if (message.decorations) {
            obj.decorations = message.decorations.map(e => (e ? Decoration.toJSON(e) : undefined));
        }
        else {
            obj.decorations = [];
        }
        return obj;
    },
};
const baseDecoration = { type: Decoration_Type.BOLD };
export const Decoration = {
    fromJSON(object) {
        const message = Object.assign({}, baseDecoration);
        message.type =
            object.type !== undefined && object.type !== null
                ? decoration_TypeFromJSON(object.type)
                : Decoration_Type.BOLD;
        message.anchorData =
            object.anchorData !== undefined && object.anchorData !== null
                ? AnchorData.fromJSON(object.anchorData)
                : undefined;
        message.colorData =
            object.colorData !== undefined && object.colorData !== null
                ? ColorData.fromJSON(object.colorData)
                : undefined;
        message.linkData =
            object.linkData !== undefined && object.linkData !== null
                ? LinkData.fromJSON(object.linkData)
                : undefined;
        message.mentionData =
            object.mentionData !== undefined && object.mentionData !== null
                ? MentionData.fromJSON(object.mentionData)
                : undefined;
        message.fontSizeData =
            object.fontSizeData !== undefined && object.fontSizeData !== null
                ? FontSizeData.fromJSON(object.fontSizeData)
                : undefined;
        message.fontWeightValue =
            object.fontWeightValue !== undefined && object.fontWeightValue !== null
                ? Number(object.fontWeightValue)
                : undefined;
        message.italicData =
            object.italicData !== undefined && object.italicData !== null
                ? Boolean(object.italicData)
                : undefined;
        message.underlineData =
            object.underlineData !== undefined && object.underlineData !== null
                ? Boolean(object.underlineData)
                : undefined;
        message.spoilerData =
            object.spoilerData !== undefined && object.spoilerData !== null
                ? SpoilerData.fromJSON(object.spoilerData)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.type !== undefined && (obj.type = decoration_TypeToJSON(message.type));
        message.anchorData !== undefined &&
            (obj.anchorData = message.anchorData ? AnchorData.toJSON(message.anchorData) : undefined);
        message.colorData !== undefined &&
            (obj.colorData = message.colorData ? ColorData.toJSON(message.colorData) : undefined);
        message.linkData !== undefined &&
            (obj.linkData = message.linkData ? LinkData.toJSON(message.linkData) : undefined);
        message.mentionData !== undefined &&
            (obj.mentionData = message.mentionData ? MentionData.toJSON(message.mentionData) : undefined);
        message.fontSizeData !== undefined &&
            (obj.fontSizeData = message.fontSizeData
                ? FontSizeData.toJSON(message.fontSizeData)
                : undefined);
        message.fontWeightValue !== undefined && (obj.fontWeightValue = message.fontWeightValue);
        message.italicData !== undefined && (obj.italicData = message.italicData);
        message.underlineData !== undefined && (obj.underlineData = message.underlineData);
        message.spoilerData !== undefined &&
            (obj.spoilerData = message.spoilerData ? SpoilerData.toJSON(message.spoilerData) : undefined);
        return obj;
    },
};
const baseMetadata = { version: 0 };
export const Metadata = {
    fromJSON(object) {
        const message = Object.assign({}, baseMetadata);
        message.version =
            object.version !== undefined && object.version !== null ? Number(object.version) : 0;
        message.createdTimestamp =
            object.createdTimestamp !== undefined && object.createdTimestamp !== null
                ? fromJsonTimestamp(object.createdTimestamp)
                : undefined;
        message.updatedTimestamp =
            object.updatedTimestamp !== undefined && object.updatedTimestamp !== null
                ? fromJsonTimestamp(object.updatedTimestamp)
                : undefined;
        message.id = object.id !== undefined && object.id !== null ? String(object.id) : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.version !== undefined && (obj.version = Math.round(message.version));
        message.createdTimestamp !== undefined &&
            (obj.createdTimestamp = message.createdTimestamp.toISOString());
        message.updatedTimestamp !== undefined &&
            (obj.updatedTimestamp = message.updatedTimestamp.toISOString());
        message.id !== undefined && (obj.id = message.id);
        return obj;
    },
};
const baseTextNodeStyle = {};
export const TextNodeStyle = {
    fromJSON(object) {
        var _a;
        const message = Object.assign({}, baseTextNodeStyle);
        message.decorations = ((_a = object.decorations) !== null && _a !== void 0 ? _a : []).map((e) => Decoration.fromJSON(e));
        message.nodeStyle =
            object.nodeStyle !== undefined && object.nodeStyle !== null
                ? NodeStyle.fromJSON(object.nodeStyle)
                : undefined;
        message.lineHeight =
            object.lineHeight !== undefined && object.lineHeight !== null
                ? String(object.lineHeight)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.decorations) {
            obj.decorations = message.decorations.map(e => (e ? Decoration.toJSON(e) : undefined));
        }
        else {
            obj.decorations = [];
        }
        message.nodeStyle !== undefined &&
            (obj.nodeStyle = message.nodeStyle ? NodeStyle.toJSON(message.nodeStyle) : undefined);
        message.lineHeight !== undefined && (obj.lineHeight = message.lineHeight);
        return obj;
    },
};
const baseDocumentStyle = {};
export const DocumentStyle = {
    fromJSON(object) {
        const message = Object.assign({}, baseDocumentStyle);
        message.headerOne =
            object.headerOne !== undefined && object.headerOne !== null
                ? TextNodeStyle.fromJSON(object.headerOne)
                : undefined;
        message.headerTwo =
            object.headerTwo !== undefined && object.headerTwo !== null
                ? TextNodeStyle.fromJSON(object.headerTwo)
                : undefined;
        message.headerThree =
            object.headerThree !== undefined && object.headerThree !== null
                ? TextNodeStyle.fromJSON(object.headerThree)
                : undefined;
        message.headerFour =
            object.headerFour !== undefined && object.headerFour !== null
                ? TextNodeStyle.fromJSON(object.headerFour)
                : undefined;
        message.headerFive =
            object.headerFive !== undefined && object.headerFive !== null
                ? TextNodeStyle.fromJSON(object.headerFive)
                : undefined;
        message.headerSix =
            object.headerSix !== undefined && object.headerSix !== null
                ? TextNodeStyle.fromJSON(object.headerSix)
                : undefined;
        message.paragraph =
            object.paragraph !== undefined && object.paragraph !== null
                ? TextNodeStyle.fromJSON(object.paragraph)
                : undefined;
        message.blockquote =
            object.blockquote !== undefined && object.blockquote !== null
                ? TextNodeStyle.fromJSON(object.blockquote)
                : undefined;
        message.codeBlock =
            object.codeBlock !== undefined && object.codeBlock !== null
                ? TextNodeStyle.fromJSON(object.codeBlock)
                : undefined;
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.headerOne !== undefined &&
            (obj.headerOne = message.headerOne ? TextNodeStyle.toJSON(message.headerOne) : undefined);
        message.headerTwo !== undefined &&
            (obj.headerTwo = message.headerTwo ? TextNodeStyle.toJSON(message.headerTwo) : undefined);
        message.headerThree !== undefined &&
            (obj.headerThree = message.headerThree
                ? TextNodeStyle.toJSON(message.headerThree)
                : undefined);
        message.headerFour !== undefined &&
            (obj.headerFour = message.headerFour ? TextNodeStyle.toJSON(message.headerFour) : undefined);
        message.headerFive !== undefined &&
            (obj.headerFive = message.headerFive ? TextNodeStyle.toJSON(message.headerFive) : undefined);
        message.headerSix !== undefined &&
            (obj.headerSix = message.headerSix ? TextNodeStyle.toJSON(message.headerSix) : undefined);
        message.paragraph !== undefined &&
            (obj.paragraph = message.paragraph ? TextNodeStyle.toJSON(message.paragraph) : undefined);
        message.blockquote !== undefined &&
            (obj.blockquote = message.blockquote ? TextNodeStyle.toJSON(message.blockquote) : undefined);
        message.codeBlock !== undefined &&
            (obj.codeBlock = message.codeBlock ? TextNodeStyle.toJSON(message.codeBlock) : undefined);
        return obj;
    },
};
function fromTimestamp(t) {
    let millis = Number(t.seconds) * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === 'string') {
        return new Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
//# sourceMappingURL=rich_content.js.map